import { EllipsisOutlined } from '@ant-design/icons'
import { Dropdown, Menu, message } from 'antd'
import { t } from 'i18next'
import './ActionOption.scss'
import { DeleteCompensationDataApi } from 'api'

export const ActionOption = ({
    record,
    index,
    action,
    data,
    setData,
    setNeedUpdate,
    setIsmodifyTable,
    Compensation,
    projectId,
    setIsModalVisible,
    setParentId,
    delRefreshDataFun,
    setEditData,
    FormRef,
    saveData,
    setSaveData,
}) => {
    return [
        <Dropdown
            key='actionDropDown'
            overlayClassName='actionDropDown'
            arrow={true}
            trigger={['click']}
            overlay={
                <Menu
                    items={[
                        !Compensation && {
                            label: (
                                <div
                                    className='insertRowBtn optionBtn'
                                    onClick={() => {
                                        action.addEditRecord(
                                            { id: Date.now(), count: String(index), isInsert: true }, // 往最后一行新增, 记下需要插入的索引
                                            { newRecordType: 'dataSource' } // 新增行默认可编辑模式
                                        )
                                    }}
                                >
                                    {t('common.insertRow')}
                                </div>
                            ),
                            key: 'insert',
                        },
                        Compensation && {
                            label: (
                                <div
                                    className='addRowBtn optionBtn'
                                    onClick={() => {
                                        setIsModalVisible(true)
                                        const sort = record?.children ? record?.children?.length + 1 : 1
                                        FormRef?.current?.setFieldsValue({ sort: sort })
                                        setParentId(record.id)
                                    }}
                                >
                                    {t('common.addRow')}
                                </div>
                            ),
                            key: 'add',
                        },
                        Compensation && {
                            label: (
                                <div
                                    className='addRowBtn optionBtn'
                                    onClick={() => {
                                        setIsModalVisible(true)
                                        setEditData(record)
                                        FormRef?.current?.setFieldsValue(record)
                                    }}
                                >
                                    {t('common.edit')}
                                </div>
                            ),
                            key: 'edit',
                        },
                        record?.fillType === 'input' && {
                            label: (
                                <div
                                    className='deleteBtn optionBtn'
                                    onClick={e => {
                                        if (Compensation) {
                                            DeleteCompensationDataApi(record.id).then(res => {
                                                message.success(t('common.tips4'))
                                                delRefreshDataFun()
                                            })
                                        } else {
                                            e.preventDefault() // 阻止默认事件
                                            e.stopPropagation() // 阻止点击事件传播
                                            setData(data.filter(item => item.id !== record.id))
                                            setIsmodifyTable(true)
                                        }
                                    }}
                                >
                                    {t('common.delete')}
                                </div>
                            ),
                            key: 'delete',
                        },
                        !Compensation && {
                            label: (
                                <div
                                    className='deleteBtn optionBtn'
                                    onClick={e => {
                                        if (Compensation) {
                                            DeleteCompensationDataApi(record.id).then(res => {
                                                message.success(t('common.tips4'))
                                                delRefreshDataFun()
                                            })
                                        } else {
                                            e.preventDefault() // 阻止默认事件
                                            e.stopPropagation() // 阻止点击事件传播
                                            setData(data.filter(item => item.id !== record.id))
                                            setIsmodifyTable(true)
                                            if (saveData) {
                                                const type = typeof record?.id === 'string'
                                                if (!type) return
                                                let delData = [...saveData]
                                                const saveIndex = saveData.findIndex(item => item?.id === record?.id)
                                                if (saveIndex !== -1) {
                                                    delData[saveIndex] = { ...record, saveType: 'delete' }
                                                } else {
                                                    if (!record?.id) return
                                                    delData.push({ ...record, saveType: 'delete' })
                                                }
                                                setSaveData(delData)
                                            }
                                        }
                                    }}
                                >
                                    {t('common.delete')}
                                </div>
                            ),
                            key: 'delete',
                        },
                    ]}
                />
            }
        >
            <EllipsisOutlined className='optionBtn EllipsisOutlined' />
        </Dropdown>,
    ]
}
